import React, { useMemo } from 'react'
import { Route } from 'react-router-dom'

import ViewGeneration from './ViewGeneration'
import GenerationAux from './GenerationAux'
import RequestData from './RequestData'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import ViewGenerationByHour from 'common/generation/HourlyGeneration'
import DOMGeneration from 'common/generation/HourlyGenerationDOM'

export default ({ actionPermits, envConfig }) => {
  const generation = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.VIEW_GENERATION,
          ScreenPermissions.ADMIN_GENERATION,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const generationAux = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.VIEW_GENERATION_AUX,
          ScreenPermissions.ADMIN_GENERATION_AUX,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const generationHourly = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.VIEW_GENERATION_BY_HOUR,
          ScreenPermissions.ADMIN_GENERATION_BY_HOUR,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const generationHourlyDOM = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.VIEW_GENERATION_BY_HOUR_DOM,
          ScreenPermissions.ADMIN_GENERATION_BY_HOUR_DOM,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <>
      {generationHourly && (
        <Route
          key="view-generation"
          exact
          path="/view-generation"
          component={ViewGenerationByHour}
        />
      )}

      {generation && (
        <Route
          key="view-generation"
          exact
          path="/view-generation"
          component={ViewGeneration}
        />
      )}

      {generationAux && (
        <Route
          key="view-generation"
          exact
          path="/view-generation"
          component={GenerationAux}
        />
      )}

      {generationHourlyDOM && (
        <Route
          key="view-generation"
          exact
          path="/view-generation"
          component={DOMGeneration}
        />
      )}
      {hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.REQUEST_GENERATION_DATA],
        matchAny: true,
      }) && <Route exact path="/request-generation" component={RequestData} />}
    </>
  )
}
